export default {
  routes: [
    {
      name: 'users',
      path: '/admin/users',
      component: () => import('./views/TheUsers.vue'),

    },

    {
      name: 'user',
      path: '/admin/users/:uuid',
      component: () => import('./views/TheUser.vue'),
    },
  ]
}
